import { inject, Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ToastComponent } from 'src/app/shared/components/toast/toast.component';

export interface SnackBarMessage {
  message: string;
  icon?: string;
  color?: string;
}

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  private readonly snackBar = inject(MatSnackBar);

  setMessage(message: SnackBarMessage | SnackBarMessage[]) {
    const data = { messages: Array.isArray(message) ? message : [message] };
    const config = { duration: 6000, panelClass: 'snackbar-group', data };
    this.snackBar.openFromComponent(ToastComponent, config);
  }
}
